import { createTheme } from '@mui/material';
import { backgroundSecondaryLight, blue, tealOnLight } from './brandColors';
import { productionColors, sharedThemeTokens, typography } from './shared';

export const StackLight = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: blue,
      },
      secondary: {
        main: tealOnLight,
      },
      background: {
        secondary: backgroundSecondaryLight,
      },
      action: {
        hover: 'rgba(0, 0, 0, 0.06)',
        hoverOpacity: 0.06,
        selected: 'rgba(0, 0, 0, 0.12)',
        selectedOpacity: 0.12,
      },
    },
    borderColor: 'rgba(0, 0, 0, 0.23)',
    productionColors,
    typography,
  },
  sharedThemeTokens
);
